import { globalReducer } from './Global/GlobalReducer';

export default {
    global: globalReducer,
};